// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Flat, borderless info banner - Polaris' default Banner draws a colored box-shadow border
   around status="info", which doesn't match the flat filled design. */
.premium-trial-banner .Polaris-Banner {
  box-shadow: none;
  margin-top: 24px;
  padding: 8px 10px;
}

.premium-trial-banner .Polaris-Banner--statusInfo {
  --pc-banner-background: #E0F0FF;
}

.premium-trial-banner .Polaris-Banner__Ribbon {
  align-items: center;
}

.premium-trial-banner + .premium-lock-card {
  margin-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/premium-trial-banner.css"],"names":[],"mappings":"AAAA;sEACsE;AACtE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Flat, borderless info banner - Polaris' default Banner draws a colored box-shadow border\n   around status=\"info\", which doesn't match the flat filled design. */\n.premium-trial-banner .Polaris-Banner {\n  box-shadow: none;\n  margin-top: 24px;\n  padding: 8px 10px;\n}\n\n.premium-trial-banner .Polaris-Banner--statusInfo {\n  --pc-banner-background: #E0F0FF;\n}\n\n.premium-trial-banner .Polaris-Banner__Ribbon {\n  align-items: center;\n}\n\n.premium-trial-banner + .premium-lock-card {\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
